import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getStockList = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/stock-promotion/stock/list?${queries}` });

  return data;
};

export default getStockList;
